import KuisionerView from '../views/custom/warga/kuisioner/index.vue';
import KritikSaranView from '../views/custom/warga/kritik-saran/index.vue';
import KritikSaranDetailView from '../views/custom/warga/kritik-saran/Detail.vue';

export default {
  path: '/warga',
  component: () => import("@/layouts/main.vue"),
  redirect: {name: 'kuisioner'},
  children: [
    {
      path: 'kuisioner',
      name: 'kuisioner',
      meta: {
        title: 'Kuisioner',
      },
      component: KuisionerView,
    },
    {
      path: 'kritik-saran',
      name: 'kritik-saran',
      meta: {
        title: 'Kritik & Saran',
        authRequired: true,
      },
      component: KritikSaranView,
    },
    {
      path: '/kritik-saran/:id',
      name: 'kritik-saran-detail',
      component: KritikSaranDetailView,
      meta: {
        title: 'Detail Kritik & Saran',
        authRequired: true,
      },
      props: true,
    },
  ]
}